import _prop from "ramda/es/prop";
import _isNil from "ramda/es/isNil";
import _ifElse from "ramda/es/ifElse";
import _map from "ramda/es/map";
import _isEmpty from "ramda/es/isEmpty";
import _reject from "ramda/es/reject";
import _split from "ramda/es/split";
import _fromPairs from "ramda/es/fromPairs";
import _pipe from "ramda/es/pipe";
import _test from "ramda/es/test";
import _when from "ramda/es/when";
import _curry from "ramda/es/curry";

var lmlGet = _curry(function (id, string) {
  return _when(_test(/^\d=/g), _pipe(_split(/\n|\r/g), _reject(_isEmpty), _map(_split('=')), _fromPairs, _ifElse(_pipe(_prop(id), _isNil), _prop(0), _prop(id))))(string);
});

export default lmlGet;